/*
 */
'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _tool = require("@entrylabs/tool");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = (0, _get2["default"])((0, _getPrototypeOf2["default"])(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
Entry.FieldAngle = /*#__PURE__*/function (_Entry$Field) {
  function FieldAngle(content, blockView, index) {
    var _this;
    (0, _classCallCheck2["default"])(this, FieldAngle);
    _this = _callSuper(this, FieldAngle, [content, blockView, index]);
    _this.X_PADDING = 8;
    _this.TEXT_Y_PADDING = 4;
    _this._block = blockView.block;
    _this._blockView = blockView;
    _this.box = new Entry.BoxModel();
    _this.svgGroup = null;
    _this.position = content.position;
    _this._contents = content;
    _this._index = index;
    var value = _this.getValue();
    _this.setValue(FieldAngle._refineDegree(value !== undefined ? value : '90'));
    _this._CONTENT_HEIGHT = _this.getContentHeight();
    _this.renderStart();
    return _this;
  }
  (0, _inherits2["default"])(FieldAngle, _Entry$Field);
  return (0, _createClass2["default"])(FieldAngle, [{
    key: "renderStart",
    value: function renderStart() {
      if (this.svgGroup) {
        $(this.svgGroup).remove();
      }
      this.svgGroup = this._blockView.contentSvgGroup.elem('g', {
        "class": 'entry-input-field'
      });
      this.textElement = this.svgGroup.elem('text', {
        x: this.X_PADDING / 2,
        y: this.TEXT_Y_PADDING,
        'font-size': '11px',
        'font-family': EntryStatic.fontFamily || 'NanumGothic'
      });
      this._setTextValue();
      var width = this.getTextWidth();
      var CONTENT_HEIGHT = this._CONTENT_HEIGHT;
      this._header = this.svgGroup.elem('rect', {
        x: 0,
        y: (_.result(this.position, 'y') || 0) - CONTENT_HEIGHT / 2,
        rx: 3,
        ry: 3,
        width: width,
        height: CONTENT_HEIGHT,
        fill: '#fff',
        'fill-opacity': 0.4
      });
      this.svgGroup.appendChild(this.textElement);
      this._bindRenderOptions();
      this.box.set({
        x: 0,
        y: 0,
        width: width,
        height: CONTENT_HEIGHT
      });
    }
  }, {
    key: "renderOptions",
    value: function renderOptions() {
      var _this2 = this;
      this.optionGroup = Entry.Dom('div', {
        "class": 'entry-widget-angle',
        parent: $('body')
      });
      this.angleWidget = new _tool.Angle({
        data: {
          angle: this.getValue(),
          positionDom: this.svgGroup,
          onOutsideClick: function onOutsideClick(angle) {
            if (_this2.angleWidget) {
              _this2._applyValue(FieldAngle._refineDegree(angle));
              _this2._setTextValue();
              _this2.destroyOption();
            }
          }
        },
        container: this.optionGroup[0]
      }).on('click', function (eventName, value) {
        var nextValue = 0;
        switch (eventName) {
          case 'buttonPressed':
            {
              nextValue = _this2._getNextValue(value);
              break;
            }
          case 'backButtonPressed':
            {
              nextValue = _this2._getSubstringValue();
              break;
            }
        }
        _this2._applyValue(nextValue);
      }).on('change', function (value) {
        _this2._applyValue(String(value));
      });
      this.optionGroup.focus();
      this.optionGroup.select();
      this.optionDomCreated();
    }

    /**
     * 기존 값의 뒤에 새 값을 추가한다. 내부에서 모든 숫자는 문자열이다.
     * 규칙은 아래와 같다.
     *
     * - 마이너스 입력은 현재 값이 0 인 경우만 가능
     * - . 은 값에서 유일하게 하나만 허용한다.
     * - 현재 값이 0 혹은 -0 인 경우 0은 입력할 수 없다. 다른 숫자는 입력할 수 있다.
     *
     * @param value 이번에 입력된 값
     * @return {string} 규칙에 맞추어 정제된 값
     * @private
     */
  }, {
    key: "_getNextValue",
    value: function _getNextValue(value) {
      var returnValue = String(this.getValue());
      if (!FieldAngle._isValidInputValue(value)) {
        return returnValue;
      }
      switch (value) {
        case '-':
          if (returnValue === '0') {
            return '-';
          }
          return returnValue;
        case '.':
          if (/\./.test(returnValue) || returnValue === '-') {
            return returnValue;
          }
          break;
        case '0':
          if (returnValue.startsWith('0') || returnValue.startsWith('-0')) {
            return returnValue;
          }
          break;
        default:
          if (returnValue === '0') {
            return value;
          }
          break;
      }
      returnValue += value;
      return returnValue;
    }

    /**
     * 현재 값 블록에서 마지막 숫자를 삭제한 값을 반환한다.
     * 0 인 경우는 0 을 반환, - 인 경우는 0 을 반환한다.
     * @returns {string} 마지막 위치가 삭제된 블록 값
     * @private
     */
  }, {
    key: "_getSubstringValue",
    value: function _getSubstringValue() {
      var returnValue = String(this.getValue());
      if (returnValue.length === 1) {
        return '0';
      } else {
        return returnValue.slice(0, returnValue.length - 1);
      }
    }
  }, {
    key: "_applyValue",
    value: function _applyValue(value) {
      var rangedValue = value;
      if (Entry.Utils.isNumber(value) && value.lastIndexOf('.') !== value.length - 1) {
        rangedValue = String(rangedValue % 360);
      }
      this.setValue(rangedValue);
      this.textElement.textContent = this.getValue();
      if (this.angleWidget) {
        this.angleWidget.data = {
          angle: FieldAngle._refineDegree(value)
        };
      }
      this.resize();
    }
  }, {
    key: "resize",
    value: function resize() {
      var obj = {
        width: this.getTextWidth()
      };
      this._header.attr(obj);
      if (this.optionGroup) {
        this.optionGroup.css(obj);
      }
      this.box.set(obj);
      this._blockView.dAlignContent();
    }
  }, {
    key: "getTextWidth",
    value: function getTextWidth() {
      if (!this.textElement) return this.X_PADDING;
      return this.getTextBBox().width + this.X_PADDING;
    }
  }, {
    key: "getText",
    value: function getText() {
      var value = this.getValue();
      var reg = /&value/gm;
      if (reg.test(value)) return value.replace(reg, '');
      return value + "\xB0";
    }
  }, {
    key: "destroyOption",
    value: function destroyOption() {
      if (this.angleWidget) {
        this.angleWidget.isShow && this.angleWidget.hide();
        this.angleWidget.remove();
        this.angleWidget = null;
      }
      if (this.optionGroup) {
        this.optionGroup.remove();
      }
      _superPropGet(FieldAngle, "destroyOption", this, 3)([]);
    }
  }, {
    key: "_setTextValue",
    value: function _setTextValue() {
      this.textElement.textContent = this._convert(this.getText(), this.getValue());
    }
  }], [{
    key: "_refineDegree",
    value: function _refineDegree(value) {
      var reg = /&value/gm;
      if (reg.test(value)) return value;
      var refinedDegree = String(value).match(/[\d|\-|.|\+]+/g)[0] || 0;
      if (refinedDegree > 360) {
        refinedDegree %= 360;
      } else if (refinedDegree < 0) {
        refinedDegree = refinedDegree % 360;
      }
      refinedDegree = String(refinedDegree);
      if (refinedDegree.lastIndexOf('.') === refinedDegree.length - 1) {
        return refinedDegree.slice(0, refinedDegree.length - 1);
      }
      return refinedDegree;
    }
  }, {
    key: "_isValidInputValue",
    value: function _isValidInputValue(value) {
      return Entry.Utils.isNumber(value) || value === '-' || value === '.';
    }
  }]);
}(Entry.Field);